export const GET_CLIENT_SO_CART_START = 'GET_CLIENT_SO_CART_START';

export const GET_CLIENT_SO_CART_SUCCESS = 'GET_CLIENT_SO_CART_SUCCESS';

export const GET_CLIENT_SO_CART_FAILURE = 'GET_CLIENT_SO_CART_FAILURE';
